// extracted by mini-css-extract-plugin
var _1 = "#000";
var _2 = "pfx-CommunityFeedCard-module__body--jJi2N";
var _3 = "1260px";
var _4 = "1020px";
var _5 = "668px";
var _6 = "1550px";
var _7 = "pfx-CommunityFeedCard-module__card--yp1g5";
var _8 = "pfx-CommunityFeedCard-module__card-title--jneeu";
var _9 = "1140px";
var _a = "940px";
var _b = "100%";
var _c = "15px";
var _d = "620px";
var _e = "pfx-CommunityFeedCard-module__content--vNLDe";
var _f = "pfx-CommunityFeedCard-module__content-in-card--XrwjG";
var _10 = "#f53535";
var _11 = "rgba(0,0,0,.2)";
var _12 = "rgba(255,255,255,.38)";
var _13 = ".38";
var _14 = "rgba(255,255,255,.2)";
var _15 = "#0025ff";
var _16 = "pfx-CommunityFeedCard-module__glitch-anim--CfjQj";
var _17 = "pfx-CommunityFeedCard-module__glitch-anim-2--uqQ51";
var _18 = "#f60";
var _19 = "#41ead4";
var _1a = "#2cdd78";
var _1b = "#66ab23";
var _1c = "#f5f5f5";
var _1d = "#c3c3c3";
var _1e = "#ececec";
var _1f = "#252525";
var _20 = "#272727";
var _21 = "#c6c6c5";
var _22 = "#333";
var _23 = "#3c3c3c";
var _24 = "#9c9b9b";
var _25 = "#8c8c8c";
var _26 = "#6f6f6e";
var _27 = "#3c3c3b";
var _28 = "#373737";
var _29 = "#6a6a69";
var _2a = "#6f6f6f";
var _2b = "#9f9e9e";
var _2c = "#282828";
var _2d = "#828181";
var _2e = "#1d1d1d";
var _2f = "#979797";
var _30 = "#9c9b9b";
var _31 = "#a7a7a6";
var _32 = "#c6c6c5";
var _33 = "#d8d8d7";
var _34 = "#dddddc";
var _35 = "72px";
var _36 = "40px";
var _37 = "36px";
var _38 = "25px";
var _39 = "18px";
var _3a = "13px";
var _3b = "pfx-CommunityFeedCard-module__hidden-tag--eJFc7";
var _3c = "pfx-CommunityFeedCard-module__image--iQn61";
var _3d = "#0025ff";
var _3e = "rgba(255,255,255,.12)";
var _3f = "#6535f5";
var _40 = "pfx-CommunityFeedCard-module__link--_F1T_";
var _41 = "2px";
var _42 = "56px";
var _43 = "56px";
var _44 = "#41ead4";
var _45 = "#f60";
var _46 = "#f83600";
var _47 = "#881f00";
var _48 = "18px";
var _49 = "15px";
var _4a = "red";
var _4b = "pfx-CommunityFeedCard-module__stat--RmpTA";
var _4c = "pfx-CommunityFeedCard-module__stats--KBl8c";
var _4d = "13px";
var _4e = "rgba(255,255,255,.07)";
var _4f = "pfx-CommunityFeedCard-module__timestamp--lOMEt";
var _50 = "pfx-CommunityFeedCard-module__timestamp-in-card--fGrqJ";
var _51 = "pfx-CommunityFeedCard-module__title--uc0_H";
var _52 = "#35465c";
var _53 = "#55acee";
var _54 = "pfx-CommunityFeedCard-module__url-tag--QpETE";
var _55 = "#fff";
var _56 = "#ffce36";
var _57 = "#ffcd00";
var _58 = "red";
export { _1 as "black", _2 as "body", _3 as "breakLarge", _4 as "breakMedium", _5 as "breakSmall", _6 as "breakVLarge", _7 as "card", _8 as "cardTitle", _9 as "containerLarge", _a as "containerMedium", _b as "containerMobile", _c as "containerPaddingMobile", _d as "containerSmall", _e as "content", _f as "contentInCard", _10 as "danger", _11 as "darkElement", _12 as "disabled", _13 as "disabledOpacity", _14 as "extraLightElement", _15 as "facebook", _16 as "glitchAnim", _17 as "glitchAnim2", _18 as "google", _19 as "green", _1a as "green2", _1b as "greenColor", _1c as "grey1", _1d as "grey10", _1e as "grey2", _1f as "grey25", _20 as "grey27", _21 as "grey3", _22 as "grey33", _23 as "grey3C", _24 as "grey4", _25 as "grey41", _26 as "grey5", _27 as "grey6", _28 as "grey61", _29 as "grey6A", _2a as "grey6F", _2b as "grey7", _2c as "grey8", _2d as "grey82", _2e as "grey9", _2f as "grey97", _30 as "grey9C", _31 as "greyA7", _32 as "greyC6", _33 as "greyD8", _34 as "greyDd", _35 as "header1", _36 as "header2", _37 as "header3", _38 as "header4", _39 as "header5", _3a as "header6", _3b as "hiddenTag", _3c as "image", _3d as "klein", _3e as "lightElement", _3f as "lilac", _40 as "link", _41 as "menuBorder", _42 as "menuHeight", _43 as "menuMobileHeight", _44 as "ocean", _45 as "orange", _46 as "orange2", _47 as "orangeDark", _48 as "paragraph", _49 as "paragraphSmall", _4a as "red", _4b as "stat", _4c as "stats", _4d as "subHeaderSmall", _4e as "subtleLightElement", _4f as "timestamp", _50 as "timestampInCard", _51 as "title", _52 as "tumblr", _53 as "twitter", _54 as "urlTag", _55 as "white", _56 as "yellow", _57 as "yellowDeep", _58 as "youtube" }
